let timer = 0;

const debounce = (fn, timeout) => {
  clearTimeout(timer);
  timer = setTimeout(fn, timeout);
};

export default debounce;
